export interface Faqs {
    faqid: string;
    customer_id: string;
    faq_title: string;
    faq_description: string;
    createdDate:string;
    activeStatus: string
}